module.exports = __webpack_public_path__ + "img/学堂照片@2x.9ba0e028.png";